import React from 'react';
import { node } from 'prop-types';
import { DataProviderClient, QueryProvider } from '@thd-nucleus/data-sources';
import { getAuthHeadersForAPI, getCommonHeadersForAPI } from '@thd-nucleus/request-manager/shared';
import { AssistantProvider, MagicApronAssistantDataModel } from 'magic-apron-feature';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { getGraphqlHost } from '../../utils/assistant-utils';

const Provider = ({ children }) => (
  <AssistantProvider>
    {children}
  </AssistantProvider>
);

Provider.dataModel = MagicApronAssistantDataModel;

Provider.propTypes = {
  children: node.isRequired,
};

export const DynamicProvider = ({ children }) => {
  const isServer = typeof window === 'undefined';
  const canReadBrowserCookie = !isServer && typeof window.cookieUtils?.readBrowserCookie === 'function';
  const isDebugMode = isServer ? false : window?.isDebugMode;
  const requestMgrAuthHeaders = isServer ? {} : { ...getAuthHeadersForAPI() };
  const requestMgrHeadersForAPI = !canReadBrowserCookie ? {} : { ...getCommonHeadersForAPI({ isServer: false }) };
  const envHost = getGraphqlHost();
  const clientContext = {
    authHeaders: {
      ...requestMgrAuthHeaders
    },
    headers: {
      'X-Experience-Name': 'magic-apron-assistant',
      ...requestMgrHeadersForAPI
    },
    opts: {
      federation: true,
      disableLocalization: false
    },
    isDebugMode
  };

  return (
    <DataProviderClient
      debug={clientContext.isDebugMode}
      federation={clientContext.opts.federation}
      headers={clientContext.headers}
      authHeaders={clientContext.authHeaders}
      credentials="include"
      host={envHost}
    >
      <QueryProvider cacheKey="magic-apron-assistant-lc-unification">
        <ErrorBoundary name="magic-apron-assistant-data-provider">
          <Provider>
            {children}
          </Provider>
        </ErrorBoundary>
      </QueryProvider>
    </DataProviderClient>
  );
};

DynamicProvider.propTypes = {
  children: node.isRequired,
};
